import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { ADD, GET } from "../../../queries/layout_definition";

const Add = (props) => {
  return (
    <Mutation
      mutation={ADD}
      update={(store, { data: { createLayoutDefinition } }) => {
        const { layoutdefinition } = store.readQuery({ query: GET });
        store.writeQuery({
          query: GET,
          data: { layoutdefinition: layoutdefinition.concat([createLayoutDefinition]) }
        });
      }}
      refetchQueries={[
        {query:GET}
      ]}
      awaitRefetchQueries={true}
      >
        
      {createLayoutDefinition => (
        <Form query_f = {createLayoutDefinition} {...props}/>
      )}
    </Mutation>
  );
};

export default Add;